import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import {
  fetchBorrowerScopedList,
  LoanBorrowerScopedParams,
} from './fetchBorrowerScopedList';
import { TableColumnSchema } from 'src/utils/income/formula/tableAccess';

/** One extracted value on a loan, shaped to resolve a form_json `source`
 *  binding directly -- by document type NAME + field NAME, not ids (ids are
 *  per-tenant cuid2; form_json is shared across tenants). */
export interface LoanExtractedValue {
  documentId?: string;
  documentTypeName?: string;
  documentCreatedAt?: string;
  /** The document's versioner label (`internal`), which a
   *  `[doc:Type:version.Field]` ref filters on. Null when unversioned. */
  documentVersion?: string | null;
  fieldTypeName?: string;
  fieldValue: string | null;
  tableValue: unknown;
  /** `field_types.table_schema` for a table field -- how `[docrow:]`/
   *  `[doccol:]` name a column independently of the printed heading. */
  tableSchema?: TableColumnSchema[] | null;
}

/** Narrows the response to one person's documents. */
export type GetLoanExtractedValuesParams = LoanBorrowerScopedParams & {
  /** Read values through this income stream's Source snapshot. */
  incomeId?: string | null;
};

const getLoanExtractedValues: QueryFunction<
  LoanExtractedValue[],
  ['/loans/extracted-values', GetLoanExtractedValuesParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) return await mock([]);

  return fetchBorrowerScopedList<LoanExtractedValue>(
    'extracted-values',
    params,
    { incomeId: params.incomeId },
  );
};

export default getLoanExtractedValues;
